<ng-template #fieldComponent></ng-template>
<ion-item lines="none" *ngIf="showError">
  <ion-label>
    <ion-text color="danger">
      <p>
        <formly-validation-message [field]="field"></formly-validation-message>
      </p>
    </ion-text>
  </ion-label>
</ion-item>